import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import SearchPhraseForm from './SearchPhraseForm';

const Terms = () => (
  <div className="filter-section">
    <Grid.Row>
      <Grid
        columns="equal"
        className="heading"
      >
        <Grid.Column>
          <Header as="h4" className="text">
            Terms
          </Header>
        </Grid.Column>
      </Grid>
    </Grid.Row>
    <Grid.Row>
      <Grid className="terms">
        <Grid.Column>
          <SearchPhraseForm />
        </Grid.Column>
      </Grid>
    </Grid.Row>
  </div>
);

export default Terms;
